import { emissionsCategoriesTags } from "@aclymatepackages/subcategories";

export const findThisTagIconColor = (name) => {
  return emissionsCategoriesTags.find((tag) => tag.name === name) || {};
};

const formatTagDataObj = (tag, data) => {
  if (!data) {
    return {};
  }

  const { name, id, tonsCo2ePerMile } = data;
  const tonsCo2ePerMileObj = tonsCo2ePerMile
    ? {
        tonsCo2ePerMile,
      }
    : {};

  return {
    [tag]: {
      name,
      id,
      ...tonsCo2ePerMileObj,
    },
  };
};

export const buildFormattedTagsObjs = ({
  employees,
  vehicle,
  office,
  vendorId,
  vendorName,
  event,
}) => {
  const buildEmployeeTagProps = () => {
    if (!employees) {
      return {};
    }

    const formattedEmployees = employees.map(({ name, id }) => ({ name, id }));
    const employeeIds = formattedEmployees.map(({ id }) => id);
    return {
      employees: formattedEmployees,
      taggedEmployeesIds: employeeIds,
    };
  };

  const buildVendorTagProps = () => {
    if (!vendorId || !vendorName) {
      return {};
    }
    return { vendorId, vendorName };
  };

  const formattedEmployees = buildEmployeeTagProps();
  const formattedVehicle = formatTagDataObj("vehicle", vehicle);
  const formattedOffice = formatTagDataObj("office", office);
  const formattedVendor = buildVendorTagProps();
  const formattedEvent = formatTagDataObj("event", event);

  return {
    ...formattedEmployees,
    ...formattedVehicle,
    ...formattedOffice,
    ...formattedVendor,
    ...formattedEvent,
  };
};
